// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"48d7f233","732":"28e83b31","977":"ffd99501"}[chunkId] + ".chunk.js";
};